import * as actionTypes from "./actionTypes";
import { TAction } from "./actions";
import { IState } from "./model";

const initialState: IState = {
  items: [],
  isFetching: false,
  isConfirmActive: false,
  currentReviewer: null,
};

const reducer = (state: IState = initialState, action: TAction): IState => {
  switch (action.type) {
    case actionTypes.SET_REVIEWERS:
      return {
        ...state,
        items: action.payload,
      };
    case actionTypes.CLEAR_REVIEWERS:
      return {
        ...state,
        items: [],
      };
    case actionTypes.SET_CURRENT_REVIEWER:
      return {
        ...state,
        currentReviewer: action.payload,
      };
    case actionTypes.SET_IS_FETCHING_REVIEWERS:
      return {
        ...state,
        isFetching: true,
      };
    case actionTypes.RESET_IS_FETCHING_REVIEWERS:
      return {
        ...state,
        isFetching: false,
      };
    case actionTypes.SET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE:
      return {
        ...state,
        isConfirmActive: true,
      };
    case actionTypes.RESET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE:
      return {
        ...state,
        isConfirmActive: false,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/reviewers/reducer.ts